export const PrimaryButton = ({ text, click }) => {
    return (
        <button className="p-3 bg-orange-500 rounded-xl text-white min-w-[150px] w-fit hover:bg-cyan-600" onClick={click}>{text}</button>
    )
}
export const InactivePrimaryButton = ({ text }) => {
    return (
        <button className="p-2.5 border-2 border-slate-300 text-slate-300 rounded-xl min-w-[150px] w-fit cursor-not-allowed">{text}</button>
    )
}
export const SecondaryButton = ({ text, click }) => {
    return (
        <button className="p-2.5 border-2 border-orange-500 rounded-xl min-w-[150px] w-fit hover:border-cyan-600" onClick={click}>{text}</button>
    )
}